export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyBn-z50SaDi0NkBtUFgE87X7vziUqEhLwU',
    authDomain: 'csc-usa-prod.firebaseapp.com',
    databaseURL: 'https://csc-usa-prod.firebaseio.com',
    projectId: 'csc-usa-prod',
    storageBucket: 'csc-usa-prod.appspot.com',
    messagingSenderId: '312190712912'
  }
};
